import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const LightIcon: FC<IconProps> = ({ width = 24, height = 24 }) => {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={[0, 0, height, width].join(' ')}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1489_64231)">
          <path d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z" stroke="#818891" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 1V3" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 21V23" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.21997 4.21973L5.63997 5.63973" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18.3601 18.3604L19.7801 19.7804" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1 12H3" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12H23" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.21997 19.7804L5.63997 18.3604" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18.3601 5.63973L19.7801 4.21973" stroke="#818891" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_1489_64231">
            <rect width="24" height="24" fill="none"/>
          </clipPath>
        </defs>
    </SvgIcon>
  );
};
